import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { isIosMobileBrowser } from "../../../../base/environment/utils";
import Icon from "../../../../base/icons/components/Icon";
import { IconCopy, IconEnvelope, IconGoogle, IconOffice365, IconYahoo, } from "../../../../base/icons/svg";
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { Tooltip } from "../../../../base/tooltip";
import { copyText } from "../../../../base/util/copyText.web";
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            marginTop: theme.spacing(4),
        },
        label: {
            marginBottom: theme.spacing(2),
        },
        iconRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        iconContainer: {
            display: "block",
            padding: theme.spacing(2),
            cursor: "pointer",
        },
    };
});
/**
 * Component that renders email invite options.
 *
 * @returns {ReactNode}
 */
function InviteByEmailSection({ inviteSubject, inviteText, inviteTextiOS, }) {
    const { classes } = useStyles();
    const { t } = useTranslation();
    // const [ isActive, setIsActive ] = useState(true);
    const encodedInviteSubject = encodeURIComponent(inviteSubject);
    const encodedInviteText = encodeURIComponent(inviteText);
    const encodedInviteTextiOS = encodeURIComponent(inviteTextiOS);
    const encodedDefaultEmailText = isIosMobileBrowser()
        ? encodedInviteTextiOS
        : encodedInviteText;
    /**
     * Copies the conference invitation to the clipboard.
     *
     * @returns {void}
     */
    function _onCopyText() {
        copyText(inviteText);
    }
    /**
     * Copies the conference invitation to the clipboard.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    function _onCopyTextKeyPress(e) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            copyText(inviteText);
        }
    }
    /**
     * Renders clickable elements that each open an email client
     * containing a conference invite.
     *
     * @returns {ReactNode}
     */
    function renderEmailIcons() {
        const PROVIDER_MAPPING = [
            {
                icon: IconEnvelope,
                tooltipKey: "addPeople.defaultEmail",
                url: `mailto:?subject=${encodedInviteSubject}&body=${encodedDefaultEmailText}`,
            },
            {
                icon: IconGoogle,
                tooltipKey: "addPeople.googleEmail",
                url: `https://mail.google.com/mail/?view=cm&fs=1&su=${encodedInviteSubject}&body=${encodedInviteText}`,
            },
            {
                icon: IconOffice365,
                tooltipKey: "addPeople.outlookEmail",
                // eslint-disable-next-line max-len
                url: `https://outlook.office.com/mail/deeplink/compose?subject=${encodedInviteSubject}&body=${encodedInviteText}`,
            },
            {
                icon: IconYahoo,
                tooltipKey: "addPeople.yahooEmail",
                url: `https://compose.mail.yahoo.com/?To=&Subj=${encodedInviteSubject}&Body=${encodedInviteText}`,
            },
        ];
        return (React.createElement(React.Fragment, null, PROVIDER_MAPPING.map(({ icon, tooltipKey, url }, idx) => (React.createElement(Tooltip, { content: t(tooltipKey), key: idx, position: "top" },
            React.createElement("a", { "aria-label": t(tooltipKey), className: classes.iconContainer, href: url, rel: "noopener noreferrer", target: "_blank" },
                React.createElement(Icon, { src: icon })))))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.container },
            React.createElement("p", { className: classes.label }, t("addPeople.shareInvite")),
            React.createElement("div", { className: classes.iconRow },
                React.createElement(Tooltip, { content: t("addPeople.copyInvite"), position: "top" },
                    React.createElement("div", { "aria-label": t("addPeople.copyInvite"), className: classes.iconContainer, 
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick: _onCopyText, 
                        // eslint-disable-next-line react/jsx-no-bind
                        onKeyPress: _onCopyTextKeyPress, role: "button", tabIndex: 0 },
                        React.createElement(Icon, { src: IconCopy }))),
                renderEmailIcons()))));
}
export default InviteByEmailSection;
